module.exports = __webpack_public_path__ + "img/PT_A.30d2b214.png";